var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "youtube",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 38.838,
    height: 27.51,
    viewBox: "0 0 38.838 27.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".youtube .a{fill:none;}.youtube .c{fill:#fff;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 38.838,
    height: 27.51
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M19.419,27.51c-.1,0-10.132-.1-13.205-.394-.147-.028-.323-.049-.527-.074a5.707,5.707,0,0,1-3.756-1.6C.78,24.271.392,21.589.388,21.562A60.16,60.16,0,0,1,0,15.232V12.264a60.219,60.219,0,0,1,.388-6.33c0-.027.392-2.709,1.543-3.882A5.333,5.333,0,0,1,5.576.422C5.667.413,5.749.4,5.823.4,11.2,0,19.329,0,19.41,0h.017c.082,0,8.214,0,13.588.4.074.009.158.017.247.026a5.33,5.33,0,0,1,3.644,1.63c1.15,1.173,1.54,3.855,1.544,3.882a60.178,60.178,0,0,1,.388,6.33v2.967a60.2,60.2,0,0,1-.388,6.33c0,.027-.394,2.709-1.544,3.882a5.336,5.336,0,0,1-3.64,1.631c-.091.009-.176.017-.251.026C27.638,27.494,19.5,27.51,19.419,27.51ZM15.407,7.838V18.828L25.9,13.352Z",
    transform: "translate(0 0)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.04524b86.svg";
export { ForwardRef as ReactComponent };